module.exports = __webpack_public_path__ + "img/freehand-jp.33bd9a4.jpg";